import store from '../index';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

function defaultState() {
	return {
		mainProduct: null,
		defaultProductId: null,
		groupData: null,
		urlList: null,
		configComponentList: [],
		exchanges: {},
		baseConfig: {},
		configError: null,
		compability: {
			class: 'loading',
			message: 'Laddar',
			shortText: '',
			components: {}
		},
	};
}

store.registerModule('config', {
	namespaced: true,
	state: defaultState(),
	getters,
	mutations,
	actions,
});

export {
	defaultState,
};